import { c as _c } from "react/compiler-runtime";
import TransferSingle from "@/components/nft-transfer/TransferSingle";
import { MEMES_CONTRACT, NULL_ADDRESS } from "@/constants";
import type { NFT, NftRank, NftTDH } from "@/entities/INFT";
import { CollectedCollectionType } from "@/entities/IProfile";
import type { ConsolidatedTDH } from "@/entities/ITDH";
import type { Transaction } from "@/entities/ITransaction";
import { ContractType } from "@/enums";
import { areEqualAddresses, numberWithCommas, printMintDate } from "@/helpers/Helpers";
import { Col, Container, Row, Table } from "react-bootstrap";
import LatestActivityRow from "../latest-activity/LatestActivityRow";
import styles from "./TheMemes.module.scss";
export function MemePageYourCardsRightMenu(props) {
  const $ = _c(46);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = function getTokenCount(transactions) {
      let count = 0;
      [...transactions].map(e => {
        count = count + e.token_count;
        count;
      });
      return count;
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const getTokenCount = t0;
  if (props.show) {
    let T0;
    let T1;
    let T2;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    if ($[1] !== props.myOwner || $[2] !== props.myRank || $[3] !== props.myTDH || $[4] !== props.nft || $[5] !== props.nftBalance || $[6] !== props.transactions || $[7] !== props.wallets) {
      const firstAcquired = [...props.transactions].sort(_temp)[0];
      const airdropped = props.transactions.filter(_temp2);
      const transferredIn = props.wallets.length === 0 ? [] : props.transactions.filter(t_0 => !areEqualAddresses(t_0.from_address, NULL_ADDRESS) && props.wallets.some(w => areEqualAddresses(t_0.to_address, w)) && t_0.value === 0);
      const transferredOut = props.wallets.length === 0 ? [] : props.transactions.filter(t_1 => props.wallets.some(w_0 => areEqualAddresses(t_1.from_address, w_0)) && t_1.value === 0);
      const bought = props.wallets.length === 0 ? [] : props.transactions.filter(t_2 => props.wallets.some(w_1 => areEqualAddresses(t_2.to_address, w_1)) && t_2.value > 0);
      let boughtSum = 0;
      bought.map(b_0 => {
        boughtSum = boughtSum + b_0.value;
        boughtSum;
      });
      const sold = props.wallets.length === 0 ? [] : props.transactions.filter(t_3 => props.wallets.some(w_2 => areEqualAddresses(t_3.from_address, w_2)) && t_3.value > 0);
      let soldSum = 0;
      sold.map(b_1 => {
        soldSum = soldSum + b_1.value;
        soldSum;
      });
      T2 = Col;
      if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
          span: 12
        };
        t6 = {
          span: 12
        };
        t7 = {
          span: 6
        };
        t8 = {
          span: 6
        };
        $[19] = t5;
        $[20] = t6;
        $[21] = t7;
        $[22] = t8;
      } else {
        t5 = $[19];
        t6 = $[20];
        t7 = $[21];
        t8 = $[22];
      }
      T1 = Container;
      t4 = "p-0";
      T0 = Row;
      if ($[23] !== props.wallets.length) {
        t1 = props.wallets.length === 0 && <Row className="pt-2"><Col><h4>Connect your wallet to view your cards.</h4></Col></Row>;
        $[23] = props.wallets.length;
        $[24] = t1;
      } else {
        t1 = $[24];
      }
      if ($[25] !== props.nft || $[26] !== props.nftBalance || $[27] !== props.wallets.length) {
        t2 = props.nftBalance === 0 && props.wallets.length > 0 && props.nft && <Row className="pt-2"><Col><h3>You don't own any editions of Card {props.nft.id}</h3></Col></Row>;
        $[25] = props.nft;
        $[26] = props.nftBalance;
        $[27] = props.wallets.length;
        $[28] = t2;
      } else {
        t2 = $[28];
      }
      t3 = props.transactions.length > 0 && props.wallets.length > 0 && <>{props.nftBalance > 0 && props.myOwner && <><Row className="pt-2"><Col xs={{
              span: 12
            }} sm={{
              span: 12
            }} md={{
              span: 12
            }} lg={{
              span: 8
            }}><Table bordered={false}><tbody><tr className={`${styles.overviewColumn}`}><td>Cards</td><td className="text-right">{`x${props.nftBalance}`}</td></tr></tbody></Table></Col></Row>{props.nftBalance > 0 && props.myOwner && props.nft?.id && <Row className="mb-2"><Col><TransferSingle collectionType={CollectedCollectionType.MEMES} contractType={ContractType.ERC1155} contract={MEMES_CONTRACT} tokenId={props.nft?.id} max={props.nftBalance} title={props.nft?.name ?? `The Memes #${props.nft?.id}`} thumbUrl={props.nft?.thumbnail} /></Col></Row>}{props.myRank && props.nft && props.myTDH ? <Row className="pt-2"><Col xs={{
              span: 12
            }} sm={{
              span: 12
            }} md={{
              span: 12
            }} lg={{
              span: 8
            }}><Table bordered={false}><tbody><tr className={`pt-1 ${styles.overviewColumn}`}><td>TDH</td><td className="text-right">{numberWithCommas(Math.round(props.myTDH.tdh))}</td></tr><tr className={`${styles.overviewColumn}`}><td>Rank</td><td className="text-right">#{props.myRank?.rank}</td></tr></tbody></Table></Col></Row> : <Row className="pb-3"><Col className={`pt-1 ${styles.overviewColumn}`}>No TDH accrued</Col></Row>}</>}<Row className="pt-2 pb-2"><Col><h3>Overview</h3></Col></Row><Row className={`pb-2 ${styles.overviewColumn}`}><Col>First acquired{" "}{printMintDate(new Date(firstAcquired.transaction_date))}</Col></Row>{airdropped.length > 0 && <Row className={`pt-1 ${styles.overviewColumn}`}><Col>{getTokenCount(airdropped)} card{getTokenCount(airdropped) > 1 && "s"} airdropped</Col></Row>}{bought.length > 0 && <Row className={`pt-1 ${styles.overviewColumn}`}><Col>{getTokenCount(bought)} card{getTokenCount(bought) > 1 && "s"} bought for {boughtSum}{" "}ETH</Col></Row>}{transferredIn.length > 0 && <Row className={`pt-1 ${styles.overviewColumn}`}><Col>{getTokenCount(transferredIn)} card{getTokenCount(transferredIn) > 1 && "s"} transferred in</Col></Row>}{sold.length > 0 && <Row className={`pt-1 ${styles.overviewColumn}`}><Col>{getTokenCount(sold)} card{getTokenCount(sold) > 1 && "s"} sold for {soldSum} ETH</Col></Row>}{transferredOut.length > 0 && <Row className={`pt-1 ${styles.overviewColumn}`}><Col>{getTokenCount(transferredOut)} card{getTokenCount(transferredOut) > 1 && "s"} transferred out</Col></Row>}</>;
      $[1] = props.myOwner;
      $[2] = props.myRank;
      $[3] = props.myTDH;
      $[4] = props.nft;
      $[5] = props.nftBalance;
      $[6] = props.transactions;
      $[7] = props.wallets;
      $[8] = T0;
      $[9] = T1;
      $[10] = T2;
      $[11] = t1;
      $[12] = t2;
      $[13] = t3;
      $[14] = t4;
      $[15] = t5;
      $[16] = t6;
      $[17] = t7;
      $[18] = t8;
    } else {
      T0 = $[8];
      T1 = $[9];
      T2 = $[10];
      t1 = $[11];
      t2 = $[12];
      t3 = $[13];
      t4 = $[14];
      t5 = $[15];
      t6 = $[16];
      t7 = $[17];
      t8 = $[18];
    }
    let t9;
    if ($[29] !== T0 || $[30] !== t1 || $[31] !== t2 || $[32] !== t3) {
      t9 = <T0>{t1}{t2}{t3}</T0>;
      $[29] = T0;
      $[30] = t1;
      $[31] = t2;
      $[32] = t3;
      $[33] = t9;
    } else {
      t9 = $[33];
    }
    let t10;
    if ($[34] !== T1 || $[35] !== t4 || $[36] !== t9) {
      t10 = <T1 className={t4}>{t9}</T1>;
      $[34] = T1;
      $[35] = t4;
      $[36] = t9;
      $[37] = t10;
    } else {
      t10 = $[37];
    }
    let t11;
    if ($[38] !== T2 || $[39] !== t10 || $[40] !== t5 || $[41] !== t6 || $[42] !== t7 || $[43] !== t8) {
      t11 = <T2 xs={t5} sm={t6} md={t7} lg={t8}>{t10}</T2>;
      $[38] = T2;
      $[39] = t10;
      $[40] = t5;
      $[41] = t6;
      $[42] = t7;
      $[43] = t8;
      $[44] = t11;
    } else {
      t11 = $[44];
    }
    return t11;
  } else {
    let t1;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <></>;
      $[45] = t1;
    } else {
      t1 = $[45];
    }
    return t1;
  }
}
function _temp2(t) {
  return t.value === 0 && areEqualAddresses(t.from_address, NULL_ADDRESS);
}
function _temp(a, b) {
  return a.transaction_date > b.transaction_date ? 1 : -1;
}
export function MemePageYourCardsSubMenu(props) {
  const $ = _c(5);
  if (props.show) {
    let t0;
    if ($[0] !== props.transactions) {
      t0 = props.transactions.length > 0 && <><Row className="pt-4"><Col><h3>Your Transaction History</h3></Col></Row><Row className={`pt-4 ${styles.transactionsScrollContainer}`}><Col><Table bordered={false} className={styles.transactionsTable}><tbody>{props.transactions.map(_temp3)}</tbody></Table></Col></Row></>;
      $[0] = props.transactions;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    let t1;
    if ($[2] !== t0) {
      t1 = <>{t0}</>;
      $[2] = t0;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  } else {
    let t0;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <></>;
      $[4] = t0;
    } else {
      t0 = $[4];
    }
    return t0;
  }
}
function _temp3(tr) {
  return <LatestActivityRow tr={tr} key={`${tr.from_address}-${tr.to_address}-${tr.transaction}-${tr.token_id}`} />;
}